import React, { createContext, useState, useContext } from "react";

interface WorkproductContextType {
  workproductId: string | null;
  setWorkproductId: (id: string | null) => void;
  analysisId: string | null;
  setAnalysisId: (id: string | null) => void;
  fileContent: string | null;
  setFileContent: (content: string | null) => void;
  analysisContent: string | null;
  setAnalysisContent: (content: string | null) => void;
  workproduct: any | null;
  setWorkproduct: (workproduct: any | null) => void;
  // Read-only mode for shared views
  readOnly: boolean;
}

const WorkproductContext = createContext<WorkproductContextType | undefined>(
  undefined
);

interface WorkproductProviderProps {
  children: React.ReactNode;
  // Optional initial values for shared/read-only views
  initialWorkproduct?: any;
  initialFileContent?: string;
  readOnly?: boolean;
}

export const WorkproductProvider: React.FC<WorkproductProviderProps> = ({
  children,
  initialWorkproduct,
  initialFileContent,
  readOnly = false,
}) => {
  const [workproductId, setWorkproductId] = useState<string | null>(
    initialWorkproduct?.id || null
  );
  const [analysisId, setAnalysisId] = useState<string | null>(null);
  const [fileContent, setFileContent] = useState<string | null>(
    initialFileContent || null
  );
  const [analysisContent, setAnalysisContent] = useState<string | null>(null);
  const [workproduct, setWorkproduct] = useState<any | null>(
    initialWorkproduct || null
  );

  return (
    <WorkproductContext.Provider
      value={{
        workproductId,
        setWorkproductId,
        analysisId,
        setAnalysisId,
        fileContent,
        setFileContent,
        analysisContent,
        setAnalysisContent,
        workproduct,
        setWorkproduct,
        readOnly,
      }}
    >
      {children}
    </WorkproductContext.Provider>
  );
};

export const useWorkproductContext = () => {
  const context = useContext(WorkproductContext);
  if (context === undefined) {
    throw new Error(
      "useWorkproductContext must be used within a WorkproductProvider"
    );
  }
  return context;
};
